var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileTray = function SvgFileTray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373737",
    fillRule: "evenodd",
    d: "M4.027 3.654C4.569 3.203 5.254 3 6 3h12c.715 0 1.397.187 1.946.628.55.442.895 1.081 1.04 1.851l1.498 7.116a.8.8 0 0 1 .016.155v5.252A3.007 3.007 0 0 1 19.502 21H4.498A3.007 3.007 0 0 1 1.5 18.002V12.75a.8.8 0 0 1 .016-.155l1.499-7.118c.143-.738.471-1.375 1.012-1.823m.958 1.153c-.22.183-.407.482-.498.96l-.003.013L3.174 12H9a.75.75 0 0 1 .75.75 2.25 2.25 0 0 0 4.5 0A.75.75 0 0 1 15 12h5.826l-1.31-6.22-.003-.018c-.091-.492-.285-.787-.506-.964-.225-.18-.55-.298-1.007-.298H6c-.473 0-.796.125-1.015.307M21 13.5h-5.326a3.75 3.75 0 0 1-7.348 0H3v4.499A1.506 1.506 0 0 0 4.501 19.5H19.5A1.506 1.506 0 0 0 21 17.999z",
    clipRule: "evenodd"
  })));
};
export default SvgFileTray;